import LayerSection from "./modules/LayerSection";
import Swiper from './modules/Swiper';
import Scrollbar from 'smooth-scrollbar';
import Layer from './modules/Layer';
import MoviePlayer from "./common/MoviePlayer";
import YTplayer from './common/YTplayer';
import TabMenu from "./modules/Tabmenu";
import { isMobileEnv } from './common/util';

class LayerInit {
  constructor() {
    this.lyaers = {};
    this.swipers = {};
    this.videos = {};
    this.tabs = {};
    this.currentLayer = null;
    this.setSectionLayer();
    this.setLayer();
  }

  setSectionLayer() {
    const layerBtns = $('[data-module-id="layer-section"]');
    layerBtns.on('click', ({ currentTarget }) => {

      const targetName = currentTarget.dataset.layerTarget;
      const layer = this.lyaers[targetName];

      if (layer) {
        layer.show();
        if (this.videos[targetName]) {
          this.videos[targetName].play();
          this.videos[targetName].outer.css('height', this.videos[targetName].outer.width() * 0.5645);
        }
      } else {
        this.lyaers[targetName] = new LayerSection({
          layer: $('#' + targetName),
          linked: currentTarget,
          options: {
            name: targetName
          },
          onBeforeHide: (e) => {
            this.hideSectionLayer(e.manager.options.name);
            $('#container').trigger('layer.close', '#' + targetName);
          },
          onShow: () => {
            $('#container').trigger('layer.open', '#' + targetName);
          },
        })
        this.setSectionSwaper(targetName);
        this.setSectionVideo(targetName);
        this.setSkillSectionVideo(targetName);
        this.setTabMenu(targetName);
      }
    });
  }

  setSectionSwaper(targetName) {
    const swipers = $('#' + targetName).find('.swiper-container');
    const scrollCon = document.querySelector('#' + targetName + ' .scrollbar-inner');
    if (swipers.length > 0) {
      this.swipers[targetName] = new Array();
      for (let i = 0; i < swipers.length; i++) {
        const swiperCon = $(swipers[i]);
        let nextEl = $(swiperCon).parent().parent().find('.swiper-button-next')
        let prevEl = $(swiperCon).parent().parent().find('.swiper-button-prev')
        let paginationEl = $(swiperCon).parent().parent().find('.swiper-pagination')
        let initialSlide = 0;
        if (targetName == 'layer-living-newclass') {
          initialSlide = 2;
        }
        if (targetName == 'layer-living-interview') {
          nextEl = $(swiperCon).find('.swiper-button-next')
          prevEl = $(swiperCon).find('.swiper-button-prev')
          paginationEl = $(swiperCon).find('.swiper-pagination')
        }
        this.swipers[targetName][i] = new Swiper(swiperCon, {
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
          initialSlide: initialSlide,
          pagination: {
            el: paginationEl
          },
          on: {
            init: () => {
              if (scrollCon) Scrollbar.init(scrollCon, { alwaysShowTracks: true }); //, {alwaysShowTracks:true}
            }
          }
        });
      }
    } else {
      Scrollbar.init(scrollCon, { alwaysShowTracks: true });
    }
  }
  setSectionVideo(targetName) {
    const eles = $('#' + targetName).find('[data-module-id="video"]');
    if (eles.length <= 0) return;

    const ele = eles[0];
    this.videos[targetName] = new YTplayer({ el_id: ele, el_outer: $(ele).parent(), videoId: ele.dataset.videoUrl, playerVars: { autoplay: 1, controls: 1, mute: false } })


  }
  setSkillSectionVideo(targetName) {
    const btns = $('#' + targetName).find('[data-module-id="layer-skill-movie"]');
    if (btns.length <= 0) return;
    btns.on('click', ({ currentTarget }) => {
      const movieurl = currentTarget.dataset.movie;
      const positionId = currentTarget.dataset.moviePosition;
      this.createSkillMovie(movieurl, positionId)
    })
    $('#' + targetName).on('click', '.newclass-skill__movie-bg', (e) => {
      // $('.newclass-skill__movie video').attr('src', '')
      $('.newclass-skill__movie').remove();
    })
  }
  createSkillMovie(url, positionId) {
    const templ = `<div class="newclass-skill__movie newclass-skill__movie--${positionId}">
                          <div class="newclass-skill__movie-bg"></div>
                          <video autoplay="true" loop controls>
                            <source src="${url}" type="video/mp4" />
                          </video>
                       </div>`;
    if (isMobileEnv($('body'))) {
      $('#layer-living-newclass').append(templ);
    } else {
      $('#layer-living-newclass .scroll-content').append(templ);
    }
  }
  setTabMenu(targetName) {
    const eles = $('#' + targetName).find('[data-module-id="tab"]');
    if (eles.length <= 0) return;
    for (let i = 0; i < eles.length; i++) {
      const tab = $(eles[i]);
      this.tabs[targetName] = new TabMenu({
        ele: tab,
        selected: 'tab1'
      });
    }
  }
  hideSectionLayer(layerName) {
    this.currentLayer = null;

    if (this.swipers[layerName]) {
      const swiperArr = this.swipers[layerName];
      for (let i = 0; i < swiperArr.length; i++) {

        if ('layer-living-newclass' == layerName) {
          swiperArr[i].slideTo(2, 0)
        } else {
          swiperArr[i].slideTo(0, 0)
        }
      }
    }
    if (this.videos[layerName]) {
      this.videos[layerName].stop();

    }
    if (this.tabs[layerName]) {
      this.tabs[layerName].select = 'tab1';

    }
  }

  setLayer() {
    $('[data-module-id="layer"]').on('click', ({
      currentTarget
    }) => {
      const targetName = currentTarget.dataset.layerTarget;
      const layer = this.lyaers[targetName];
      if (layer) {
        layer.show();
      } else {
        this.makeLayer(targetName, currentTarget);
      }
    });
  }

  dirLayerOpen(layerSelector) {
    if (layerSelector) {
      const layer = this.lyaers[layerSelector];
      if (layer) {
        layer.show();
      } else {
        this.makeLayer(layerSelector, $(`[data-layer-target="${layerSelector}"]`)[0]);
      }
    }
  }

  makeLayer(_layerSelector, _currentTarget) {
    let LayerMom = ($(_layerSelector).hasClass('layer-section')) ? LayerSection : Layer;

    this.lyaers[_layerSelector] = new LayerMom({
      layer: $(_layerSelector),
      linked: _currentTarget,
      options: {
        noScroll: false,
        keepDimmed: true,
      },
      onBeforeShow: () => { },
      onShow: () => {
        $('#container').trigger('layer.open', _layerSelector);
      },
      onBeforeHide: () => {
        $('#container').trigger('layer.close', _layerSelector);
      },
    });

    const scrollCon = document.querySelector(_layerSelector + ' .scrollbar-inner');
    if (scrollCon) Scrollbar.init(scrollCon);
  }




}

export default LayerInit;